import { Schema } from "effect";
import { FlowRecordingMode, FlowRecordingState } from "@workerstation/shared/flow-recording-model";
import { RecordingResponses } from "@workerstation/shared/recording/api";
import { RecordingIdentity } from "@workerstation/shared/recording/model";
import { ResourceStorageError } from "@workerstation/shared/errors/resource";

export class RecordingRequestError extends Schema.TaggedError<RecordingRequestError>()("RecordingRequestError", {
  status: Schema.Literals([400, 403, 404, 405, 409, 410, 413, 416]), message: Schema.String
}) {}
export const RecordingFailure = Schema.Union([RecordingRequestError, ResourceStorageError]);
export type RecordingFailure = typeof RecordingFailure.Type;
export const RecordingFilters = Schema.Struct({
  flowName: Schema.optionalKey(Schema.String), mode: Schema.optionalKey(FlowRecordingMode),
  state: Schema.optionalKey(FlowRecordingState), sessionId: Schema.optionalKey(Schema.String)
});
export type RecordingFilters = typeof RecordingFilters.Type;
export const RecordingTarget = RecordingIdentity;
export type RecordingTarget = typeof RecordingTarget.Type;
export type RecordingListing = typeof RecordingResponses.list.Type;
export type RecordingManifest = typeof RecordingResponses.inspect.Type;
export type RecordingDeleted = typeof RecordingResponses.delete.Type;
export type RecordingExport = typeof RecordingResponses.export.Type;
export const RecordingMedia = Schema.Struct({
  bytes: Schema.Uint8Array, status: Schema.Literals([200, 206]),
  contentType: Schema.optionalKey(Schema.String), contentRange: Schema.optionalKey(Schema.String),
  acceptRanges: Schema.optionalKey(Schema.String)
});
export type RecordingMedia = typeof RecordingMedia.Type;
